import React from 'react'
import { Descriptions, Tag, Tooltip } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'

export default function FiltersDisplay({ filters, resetAction }) {
  const hasFilters =
    !!Object.keys(filters).length &&
    Object.values(filters).some(
      (filter: []) => Array.isArray(filter) && !!filter?.length
    )

  return hasFilters ? (
    <Descriptions size="small">
      <Descriptions.Item label="Searching For">
        {Object.values(filters).map(
          (filter: string, i) =>
            Array.isArray(filter) &&
            !!filter.length && (
              <Tag color="blue" key={i} data-testid="table_filter_search_value">
                {filter}
              </Tag>
            )
        )}
        <Tooltip title="Clear All Filters">
          <CloseCircleOutlined onClick={() => resetAction()} />
        </Tooltip>
      </Descriptions.Item>
    </Descriptions>
  ) : null
}
